import React from "react";
import classnames from "classnames";
import PropTypes from "prop-types";

const LoginInput = ({
  name,
  placeholder,
  value,
  error,
  type,
  onChange,
  icon,
}) => {
  return (
    <div className="mb-3 input-group">
    
      <input
        type={type}
        className={classnames("form-control  border-primary", {
          "is-invalid": error,
        })}
        aria-describedby="emailHelp"
        autoComplete="off"
        placeholder={placeholder}
        name={name}
        value={value}
        onChange={onChange}
      />
      {error && <div className="invalid-feedback">{error}</div>}
    </div>
  );
};

LoginInput.propTypes = {
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  error: PropTypes.string,
  type: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  icon: PropTypes.string.isRequired,
};

export default LoginInput;
